const STORAGE_KEY_PREFIX = 'st:drtail'

export const STORAGE_KEYS = {
  ACCESS_TOKEN: `${STORAGE_KEY_PREFIX}:access-token`,
  REFRESH_TOKEN: `${STORAGE_KEY_PREFIX}:refresh-token`,
  GUEST_TOKEN: `${STORAGE_KEY_PREFIX}:guest-token`,
  GUEST_ACCOUNT_ID: `${STORAGE_KEY_PREFIX}:guest-account-id`,
  DEVICE_ID: `${STORAGE_KEY_PREFIX}:device-id`,
  ROOT_PATH: `${STORAGE_KEY_PREFIX}:root-path`,
  CONSULTATION_DATA: `${STORAGE_KEY_PREFIX}:consultation-data`,
  CONSULTATION_METADATA: `${STORAGE_KEY_PREFIX}:consultation-metadata`,
  OAUTH2_PARAMS: `${STORAGE_KEY_PREFIX}:oauth2-params`,
  // 최근 소비한 진입 OTP 목록(JSON 배열). 같은 OTP 로 로그인을 재시도하지 않기 위한 표식.
  SPENT_OTPS: `${STORAGE_KEY_PREFIX}:spent-otps`,
}

export const MEDIA_FALLBACK_URL = `${import.meta.env.VITE_STATIC_RES}/img/media_default.webp`

export const AVATAR_DEFAULT = {
  OWNER: `${import.meta.env.VITE_STATIC_RES}/img/avatar_owner_default_3x.webp`,
  VET: `${import.meta.env.VITE_STATIC_RES}/img/avatar_vet_3x.webp`,
  PET: {
    CAT: `${import.meta.env.VITE_STATIC_RES}/img/avatar_pet_default_cat_3x.webp`,
    DOG: `${import.meta.env.VITE_STATIC_RES}/img/avatar_pet_default_dog_3x.webp`,
    BIRD: `${import.meta.env.VITE_STATIC_RES}/img/avatar_pet_default_bird_3x.webp`,
    OTHERS: `${import.meta.env.VITE_STATIC_RES}/img/avatar_pet_default_others_3x.webp`,
  },
}

export const APP_AUTH_ESCAPE_ERROR_CODE = 9000
export const NOTION_PAGES = {
  TERMS_OF_SERVICE: {
    id: '2534a5270114430dadf625c271e75daa',
    uri: 'https://www.notion.so/drtail/Terms-of-Service-2534a5270114430dadf625c271e75daa',
    appUri: 'https://www.drtail.us/terms',
  },
  PRIVACY_POLICY: {
    id: '3c1632af1f304f9187510bc6cb6fd64b',
    uri: 'https://www.notion.so/drtail/Privacy-Policy-3c1632af1f304f9187510bc6cb6fd64b',
    appUri: 'https://www.drtail.us/privacy',
  },
}
